var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 7.46c-.7.74-8.1 7.95-8.1 7.95-.37.4-.86.59-1.35.59-.5 0-.98-.2-1.36-.6 0 0-7.4-7.2-8.1-7.94a2.13 2.13 0 010-2.85c.75-.78 1.8-.85 2.72 0L10 11.23l6.74-6.62c.92-.85 1.96-.78 2.71 0 .76.79.7 2.12 0 2.85z",
    fill: "currentColor"
  })));
}
export default SvgChevronDown;